import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=7894e972&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7894e972')) {
      api.createRecord('7894e972', component.options)
    } else {
      api.reload('7894e972', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=7894e972&", function () {
      api.rerender('7894e972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sML2EjdKTpRZ/JS/comp/ImgFallback.vue"
export default component.exports